import { createFileRoute } from '@tanstack/react-router'
import { CompanyEnrichment } from '@/features/admin/company-enrichment'

export const Route = createFileRoute('/_authenticated/admin/company-enrichment')(
  {
    component: CompanyEnrichment,
  }
)
